import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useEditRoleInfo = () => {
  const [loading, setLoading] = useState(false);
  const [roleEditInfo, setRoleEditInfo] = useState(null);

  const { enqueueSnackbar } = useSnackbar();

  const getRoleEditInfo = guid => {
    setLoading(true);
    setRoleEditInfo(null);

    axiosClient
      .get(`SettingAccount/Role/Update?GUID=${guid}`)
      .then(res => {
        if (res.status === 200) {
          setRoleEditInfo(res.data.value);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return [getRoleEditInfo, loading, roleEditInfo];
};

export { useEditRoleInfo };
